import { TableHeadersType } from "../../tableHeadersType";

export const AGEING_ANALYSIS_TABLE_HEADERS:TableHeadersType[]=[
    {
        label:"Ledger Number",
        value:"ledger_number",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Legal Name",
        value:"legal_name",
        checked:true,
        defaultChecked:true
    },
    {
        label:"0 to 30 days",
        value:"0_to_30_days",
        checked:true,
        defaultChecked:true
    },
    {
        label:"30 to 60 days",
        value:"30_to_60_days",
        checked:true,
        defaultChecked:true
    },
    {
        label:"60 to 90 days",
        value:"60_to_90_days",
        checked:true,
        defaultChecked:true
    },
    {
        label:"more than 90 days",
        value:"more_than_90_days",
        checked:true,
        defaultChecked:true
    },
    {
        label:"Total Amount",
        value:"total_amount",
        checked:true,
        defaultChecked:true
    },
]